import React from 'react'
import './PatientMenu.scss'
import { withData } from '../withData'
import _ from 'lodash'
import { Helmet } from 'react-helmet'
import qs from 'query-string'
import { Card } from 'antd'
import { Link } from 'react-router-dom'

const query = `
  query {
    medications() {
      displayName,
      displayImage,
      patient {
        id,
        firstname,
        lastname
      }
    }
  }
`

export const PatientMenu = ({ data, match }) => {
  console.log('match:', match)
  const patientId = _.get(match, 'params.patientId')
  const displayName = _.get(data, 'data.medications.displayName')
  const displayImage = _.get(data, 'data.medications.displayImage')
  const patient = _.get(data, 'data.medications.patient')
  const token = qs.parse(location.hash.split('?').pop()).token || localStorage.getItem('token')
  return (
    <div>
      <Helmet>
        <title>ผู้ป่วยในการดูแล</title>
      </Helmet>
      {patientId &&
        <div className="patient-info">
          <img src={displayImage || 'https://assets17.sigaccess.org/images/user_icon.png'} />
          <h2>{patient.firstname} {patient.lastname}</h2>
          <h4>{displayName}</h4>
        </div>
      }
      <div className="links">
        <Link to={`/patients/${patientId}/doses?token=${token}`} target="_blank">
          <Card className="link">
            <div className="add-dose">
              โดสยาทั้งหมด
            </div>
          </Card>
        </Link>
        <Link to={`/patients/${patientId}/medications?token=${token}`} target="_blank">
          <Card className="link">
            <div className="add-dose">
              ประวัติการทานยา
            </div>
          </Card>
        </Link>
        <Link to={`/patients/${patientId}/report?token=${token}`} target="_blank">
          <Card className="link">
            <div className="add-dose">
              สรุปผล
            </div>
          </Card>
        </Link>
      </div>
    </div>
  )
}

export default withData(query)(PatientMenu)



// WEBPACK FOOTER //
// ./src/PatientMenu/PatientMenu.js